import styled from 'styled-components'

import bannerHome from 'assets/img/banner-home.png'

export const Wrapper = styled.main`
  max-width: 1040px;
  width: 90%;
  max-height: 590px;
  height: 100vh;
  background-image: url(${bannerHome});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  margin: 90px auto;
  display: flex;
  align-items: flex-end;
  border-radius: 4px;
`

export const WrapperContent = styled.div`
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
  height: 220px;
  width: 100%;
  padding: 40px;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.25);

  span {
    color: #f231a5;
    font-weight: bold;
  }

  h1 {
    font-size: 28px;
  }

  p {
    font-size: 20px;
  }

  h1,
  p {
    margin-bottom: 16px;
  }
`
